import PropTypes from 'prop-types'
import { memo } from 'react'
import BG from 'components/core/BG/BG'
import Divider from 'components/core/Divider/Divider'
import styles from './Tabs.module.scss'

/**
 * The `Tabs`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Tabs (props) {
  const { children } = props

  return (
    <div className={styles.tabs}>
      <BG color="b" opacity="a" mask="wide" />
      <div className={styles.tabsContent}>
        <div className={styles.tabsOptions}>{children}</div>
      </div>
      <Divider mask="wide" />
    </div>
  )
}

/** @type {object} */
Tabs.propTypes = {
  children: PropTypes.node
}

/** @type {object} */
Tabs.defaultProps = {
  children: []
}

// Memoize
export default memo(Tabs)
